const comA1 = {
	length: { min: 2, max: 2 },
	payload: [
		{ length: 1, name: "código", type: "bytes", description: "Código de configuración (1 byte).", pad: "00" },
		{ length: 1, name: "value", description: "Solicitud de hibernación. Valores: '00' para hibernación, '01' para reset de fábrica. Tamaño: 1 byte.", type: "string", values: ["00", "01"], pad: "00" },
	],
};

export default comA1;
